import {Box} from '@mui/material'
import React from 'react'

import {useTimePickerStyles} from './styles'
import {WheelPickerProps} from './types'
import {WheelColumn} from './WheelColumn'

export const WheelPicker: React.FC<WheelPickerProps> = ({
  selectedIndexes,
  columns,
  onSelectedIndex,
  visibleRows = 5,
  testID
}) => {
  const classes = useTimePickerStyles()

  const handleColumnSelection = (columnIndex: number, index: number) => {
    onSelectedIndex(columnIndex, index)
  }

  return (
    <Box className={classes.wheelPickerContainer} data-testid={testID}>
      {columns.map((column, columnIndex) => (
        <WheelColumn
          key={columnIndex}
          values={column.values}
          selectedIndex={selectedIndexes[columnIndex] || 0}
          onSelectedIndex={(index) => handleColumnSelection(columnIndex, index)}
          visibleRows={visibleRows}
          separator={column.separator}
          testID={`${testID}-column-${columnIndex}`}
        />
      ))}
    </Box>
  )
}
